import { isEmpty } from 'lodash-es';

// Vertical dashed line
export const buildVerticalDashedLine = (svgAtributes) => {
  let verticalDashedLine;
  const pathSVGAtributes = {
    'stroke-width': 1,
    stroke: '#e1e5eb',
    dashstyle: 'ShortDash',
    'stroke-dasharray': '2, 2',
    ...(svgAtributes || {}),
  };

  return (renderer, coords = {
    topLeft: 0,
    topRight: 0,
    bottomLeft: 0,
    bottomRight: 0,
  }) => {
    if (!isEmpty(verticalDashedLine)) verticalDashedLine.destroy();

    verticalDashedLine = renderer.path(['M', coords.topLeft, coords.topRight, 'L', coords.bottomLeft, coords.bottomRight])
      .attr(pathSVGAtributes)
      .add();

    return () => verticalDashedLine.destroy();
  };
};

// Rects
export const buildRects = (svgAtributes) => {
  let rects = [];

  const rectSVGAtributes = {
    'stroke-width': 0,
    stroke: '#e1e5eb',
    fill: '#F8F9FB',
    ...(svgAtributes || {}),
  };

  const cleanup = () => {
    rects.forEach(rect => rect.destroy());
    rects = [];
  };

  return (renderer, coords = [], extraParams = []) => {
    if (!isEmpty(rects)) cleanup();

    rects = coords.map((coord, index) => {
      const rect = renderer.rect(
        coord.left || 0,
        coord.top || 0,
        coord.width || 1,
        coord.height || 1,
      ).attr(rectSVGAtributes);

      if (extraParams[index]?.className) {
        rect.addClass(extraParams[index]?.className);
      }

      if (extraParams[index]?.onClick) {
        rect.on('click', extraParams[index]?.onClick);
      }

      if (extraParams[index]?.mouseOver) {
        rect.on('mouseover', extraParams[index]?.mouseOver);
      }

      if (extraParams[index]?.mouseOut) {
        rect.on('mouseout', extraParams[index]?.mouseOut);
      }

      rect.add();

      return rect;
    });

    return () => cleanup();
  };
};

const lineSVGAtributes = {
  'stroke-width': 0,
  stroke: '#e1e5eb',
  fill: '#e1e5eb',
  r: 2,
  zIndex: 5,
};

// Horizontal lines
export const buildHorizontalLines = svgAtributes => buildRects({
  ...lineSVGAtributes,
  ...svgAtributes,
});

// Vertical lines
export const buildVerticalLines = svgAtributes => buildRects({
  ...lineSVGAtributes,
  ...svgAtributes,
});

// Custom borders for export charts
export const renderChartExportBorders = ({
  target: {
    plotWidth,
    chartWidth,
    chartHeight,
    yAxis,
  },
}, renderer) => {
  const withSecondAxis = yAxis.length > 1;

  const sideSizeOut = 48;
  const sideSizeFull = 88;
  const plotHeightFull = 527;
  const mainPadding = 96;
  const rightPadding = 176;
  const topMargin = 233;

  const renderHorizontalLines = buildHorizontalLines();
  const renderVerticalLines = buildVerticalLines();

  // Chart vertical borders
  renderVerticalLines(renderer, [{
    top: topMargin - 22,
    left: chartWidth - sideSizeOut + 1,
    height: plotHeightFull + mainPadding + 22,
  }, {
    top: topMargin - 22,
    left: sideSizeOut,
    height: plotHeightFull + mainPadding + 22,
  }, {
    top: topMargin,
    left: sideSizeFull,
    height: plotHeightFull + sideSizeOut,
  }, {
    top: topMargin,
    left: chartWidth - sideSizeFull,
    height: plotHeightFull + sideSizeOut,
  }, {
    top: topMargin,
    left: chartWidth - (withSecondAxis ? sideSizeFull : 0),
    height: plotHeightFull - sideSizeOut,
  }, {
    top: topMargin,
    left: 167,
    height: plotHeightFull - sideSizeOut,
  }, {
    top: topMargin,
    left: plotWidth + 168,
    height: plotHeightFull,
  }]);

  // Chart horizontal borders
  renderHorizontalLines(renderer, [{
    top: chartHeight - sideSizeOut + 4,
    left: sideSizeOut,
    width: chartWidth - mainPadding,
  }, {
    top: topMargin,
    left: sideSizeFull,
    width: plotHeightFull - sideSizeFull,
  }, {
    top: chartHeight - sideSizeFull - 4,
    left: sideSizeFull,
    width: chartWidth - rightPadding,
  }, {
    top: topMargin,
    left: sideSizeFull,
    width: chartWidth - rightPadding,
  }, {
    top: chartHeight - sideSizeFull - sideSizeOut - 4,
    left: sideSizeFull,
    width: chartWidth - rightPadding,
  }]);
};
